module.exports = __webpack_public_path__ + "static/media/moon.7c018535.svg";